var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCodeBlock = function SvgCodeBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.872 7.703a1 1 0 0 1 1.337-1.487l5.256 4.705a1 1 0 0 1 0 1.487l-5.256 4.631a1 1 0 1 1-1.337-1.486l4.43-3.889-4.43-3.961ZM8.465 15.553a1 1 0 1 1-1.338 1.487l-5.256-4.705a1 1 0 0 1 0-1.487l5.256-4.632a1 1 0 0 1 1.338 1.487l-4.43 3.888 4.43 3.962Z"
  })));
};

export default SvgCodeBlock;